<template>
  <div>
    <gg-card>
      <gg-card-header :divider="showCardText">
        <v-row :class="showCardText ? '' : 'pb-3'">
          <v-col md="6">
            Application Installer
          </v-col>
          <v-col md="6" class="text-right">
            <gg-btn primary right @click="togglePanel">
              {{ showButtonLabel }}
            </gg-btn>
          </v-col>
        </v-row>
      </gg-card-header>
      <v-expand-transition>
        <gg-card-text v-show="showCardText">
          <v-row>
            <v-col cols="12">
              <keep-alive>
                <install-app-form @app-installed="handleAppInstalled" />
              </keep-alive>
            </v-col>
          </v-row>
        </gg-card-text>
      </v-expand-transition>
    </gg-card>

    <gg-card class="mt-4">
      <gg-card-header>
        <v-row class="align-center" no-gutters>
          <v-col cols="12" md="6">
            Installed Applications
          </v-col>
          <v-col cols="12" md="6">
            <gg-text-field
              v-model="tableSearch"
              append-icon="mdi-magnify"
              placeholder="Search"
              hide-details
            />
          </v-col>
        </v-row>
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <installed-apps-table ref="installedAppsTable" :search="tableSearch" />
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import InstallAppForm from './InstallAppForm'
import InstalledAppsTable from './InstalledAppsTable'

export default {
  name: 'InstallApp',
  components: {
    InstallAppForm,
    InstalledAppsTable,
  },
  data () {
    return {
      tableSearch: '',
      showCardText: false,
    }
  },
  computed: {
    showButtonLabel () {
      return this.showCardText ? 'Hide' : 'Install Apps'
    },
  },
  methods: {
    togglePanel () {
      this.showCardText = !this.showCardText
    },
    handleAppInstalled () {
      this.$refs.installedAppsTable.handleFetchApps()
    },
  },
}
</script>
